import { Badge, List, VerticalNav } from '@bynder/design-system';
import { useActiveGuide } from '../../../queries/guides';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../constants/app';
import { Page, PageStates } from '../../../types';
import { useGuideStore } from '../../../stores/guideStore';
import React from 'react';
import { useInspectorStore } from '../../../stores/inspectorStore';
import { InspectorSetting } from '../../../constants/guides';

const AudiencePagesList: React.FC<{ pages: Page[] }> = ({ pages }) => {
  const lastIndex = pages.length - 1;

  return (
    <List>
      {pages.map((page, index) => {
        if (index !== lastIndex)
          return <AudiencePage key={page.id} page={page} />;
      })}
    </List>
  );
};

export default AudiencePagesList;

export const AudiencePage: React.FC<{
  page: Page;
  isLast?: boolean;
}> = ({ page, isLast = false }) => {
  const { data: guide, isLoading } = useActiveGuide();
  const history = useHistory();
  const activePageId = useGuideStore(s => s.activePageId);
  const setActiveInspectorSetting = useInspectorStore(
    s => s.setActiveInspectorSetting,
  );
  const navigateToPage = () => {
    if (guide) {
      setActiveInspectorSetting(InspectorSetting.PAGE_VIEW);
      history.push({
        pathname: ROUTES.GUIDE_PAGE(guide.id, page.id),
        hash: undefined,
      });
    }
  };
  const isSelected = activePageId === page.id;
  const isDraft = page.state === PageStates.DRAFT;

  if (isLoading || !guide) return null;
  return (
    <VerticalNav.Item
      isActive={isSelected}
      rightElements={[isDraft && <Badge isSecondary>Draft</Badge>]}
      onClick={navigateToPage}
    >
      {isLast ? guide.title : page.title}
    </VerticalNav.Item>
  );
};
